// extracted by css-extract-rspack-plugin
export default {"flexCenter":"Topics-module__flexCenter__L_Vva","repoIcon":"Topics-module__repoIcon__v677D"};